export var FCT_UNISWAP_V2_ADDRESS = '0xB3A577f4E5F60aef9A6e088e4373d6d2E9a1785D';
export var fctUniswapContracts = [
    { chainId: 1, address: '0xB3A577f4E5F60aef9A6e088e4373d6d2E9a1785D' },
    { chainId: 10, address: '0x1aDA5c27e803ab51256dDbA0979b58d5b72f53a8' },
    { chainId: 8453, address: '0x2b71432D7638Cb21274806645611341F3a2c1E99' },
    { chainId: 11155111, address: '0xD6cC2a617A483BB8A7836CFCd1c637984B6593d6' },
];
export var method = {
    swapExactETHForTokens: 'swap <amount> ETH for <X> Tokens',
    swapExactTokensForETH: 'swap <amount> Tokens for <X> ETH',
    swapETHForExactTokens: 'swap <X> ETH for <amount> Tokens',
    swapTokensForExactETH: 'swap <X> Tokens for <amount> ETH',
    swapExactTokensForTokens: 'swap <amount> Tokens for <X> Tokens',
    swapTokensForExactTokens: 'swap <X> Tokens for <amount> Tokens',
};
export var liquidity_method = {
    addLiquidity: 'add tokens to the liquidity pool',
    addLiquidityTokenEth: 'add token and eth to the liquidity pool',
    addLiquidityEthToken: 'add eth and token to the liquidity pool',
};
export var ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';
